import module from 'colaborador/module.js'
import template from './template.html'
import * as moment from 'moment'

const periodo = (fechaInicial, fechaFinal) => {
  const i = moment(fechaInicial).format('YYYY,MMMM,D').split(',')
  const f = moment(fechaFinal).format('YYYY,MMMM,D').split(',')
  const c = [i[0] === f[0], i[1] === f[1], i[2] === f[2]]

  if (c[0] && c[1] && c[2]) {
    return `Del ${f[2]} de ${f[1]} de ${f[0]}`
  } else if (c[0] && c[1]) {
    return `Del ${i[2]} al ${f[2]} de ${f[1]} de ${f[0]}`
  } else if (c[0]) {
    return `Del ${i[2]} de ${i[1]} al ${f[2]} de ${f[1]} de ${f[0]}`
  } else {
    return `Del ${i[2]} de ${i[1]} de ${i[0]} al ${f[2]} de ${f[1]} de ${f[0]}`
  }
}

export class ColaboradorIncapacidadesListaItemComponent {
  data
  onChange
  onDelete
  eliminando = false

  $onChanges (changes) {
    if (changes.data) {
      this.data = Object.assign({}, this.data, {
        periodo: periodo(this.data.fecha_inicial, this.data.fecha_final),
        dias_pagados: this.data.pagos.reduce((total, item) => total + item.dias_pagados, 0),
        importe: this.data.pagos.reduce((total, item) => total + item.importe, 0),
      })
    }
  }

  actualizar (data) {
    Object.assign(this.data, data)
    this.onChange({$event: {detail: this.data}})
  }

  eliminar (eliminado) {
    this.eliminando = false
    if (eliminado) {
      this.onDelete()
    }
  }
}

module.component('colaboradorIncapacidadesListaItem', {
  controller: ColaboradorIncapacidadesListaItemComponent,
  template,
  bindings: {
    data: '<',
    onChange: '&',
    onDelete: '&',
  },
})



// WEBPACK FOOTER //
// ./src/colaborador/components/incapacidades/lista/item/component.js